export const EUserType = {
   "-1": "ALL",
   0: "UNKNOWN",
   1: "STAFF",
   2: "AGENCY_ADMIN",
   3: "AGENCY_USER",
};
